export default __webpack_public_path__ + "static/media/9、维生素水产品介绍.d9642d53.jpg";